const env = process.env.NODE_ENV || "development";

const appConfig = {
    local: {
        MCP_SOCKET_SERVER_URL: 'ws://localhost:3000',
        GOOGLE_RECAPTCHA_CLIENT_KEY: '6LduSmEsAAAAAKq3YW6ZhKcMVcBPXFCxPbSyQyFR',
        UPGRADE_URL: 'https://www.forinvest.com/planlar',
    },
    development: {
        MCP_SOCKET_SERVER_URL: 'wss://forinvest-ai-dev.frks.net',
        GOOGLE_RECAPTCHA_CLIENT_KEY: '6LduSmEsAAAAAKq3YW6ZhKcMVcBPXFCxPbSyQyFR',
        UPGRADE_URL: 'https://www.forinvest.com/planlar',
    },
    production: {
        MCP_SOCKET_SERVER_URL: 'wss://formind.forinvest.com',
        GOOGLE_RECAPTCHA_CLIENT_KEY: '6LduSmEsAAAAAKq3YW6ZhKcMVcBPXFCxPbSyQyFR',
        UPGRADE_URL: 'https://www.forinvest.com/planlar',
    },
} as any;


export default {
    ...appConfig[env],
} as {
    MCP_SOCKET_SERVER_URL: string;
    GOOGLE_RECAPTCHA_CLIENT_KEY: string;
    UPGRADE_URL: string;
};
